import styled from 'styled-components'

export const FieldSet = styled.fieldset`
border:none;
padding:0;
`
